export default "__VITE_ASSET__a0a01f0d__"